import React, { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Card, Row, Col, Layout, Spin } from "antd";
import { AuthHeader } from "components";
import * as authAction from "actions/auth-action";
import { SoftColor } from "config/constants/Color";
import { useParams } from "react-router-dom";
import { authDeviceVerification } from 'services/auth-service';
import { LoadingOutlined } from "@ant-design/icons";


const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            ...authAction,
        },
        dispatch
    );

const DeviceVerification = () => {
    const { deviceName, token } = useParams();
    const [showMessage, setShowMessage] = useState(false);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);


    const onVerify = async () => {
        try {
            setShowMessage(false);
            setLoading(true);
            await authDeviceVerification(token);
            setMessage("Dispositivo liberado com sucesso.");
            setShowMessage(true);
        } catch (error) {
            setMessage("Erro ao liberar dispositivo.");
            setShowMessage(false);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        onVerify();
    }, []);

    return (
        <Layout
            style={{
                backgroundColor: SoftColor,
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "row",
            }}
        >
            <Layout.Content>
                <Row justify="center" align="middle" className="login">
                    <Col xxl={7} xl={8} lg={12} md={16} sm={24} xs={24}>
                        {loading && (
                            <Card
                                title={<AuthHeader />}
                                bordered={false}
                                className="card-login"
                                style={{ textAlign: "center" }}
                            >
                                <div style={{ marginBottom: "16px", color: "white" }}>
                                    Liberando dispositivo ({deviceName})
                                </div>
                                <Spin
                                    size="large"
                                    style={{ display: "block" }}
                                    indicator={<LoadingOutlined style={{ fontSize: 32, color: "white" }} spin />}
                                />
                            </Card>
                        )}
                        {showMessage && (
                            <Card
                                bordered={false}
                                style={{ textAlign: "center" }}
                            >
                                <div style={{ fontSize: "18px", fontWeight: "bold", marginBottom: "16px", color: "white" }}>
                                    {message}
                                </div>
                                <p style={{ color: "white" }}>Acesse ao aplicativo e efetue o login novamente.</p>
                            </Card>
                        )}
                    </Col>
                </Row>
            </Layout.Content>
        </Layout>
    );
};

export default connect(mapDispatchToProps)(DeviceVerification);
